import { useCallback, useMemo, useState } from 'react';
import { checkEnv } from '@elevator/ui';

type SlotFillKey = 'md' | 'lg' | 'single';

/**
 * Shows AdSpace only after GPT confirms a creative rendered.
 * Slots stay mounted while hidden so ad requests can still run.
 */
export const useAdSpaceVisibility = (slotKeys: SlotFillKey[]) => {
  const { isTestMode } = checkEnv();
  const [filledSlots, setFilledSlots] = useState<Partial<Record<SlotFillKey, true>>>({});

  const handleSlotFilled = useCallback((key: SlotFillKey) => {
    return () => {
      setFilledSlots((prev) => ({ ...prev, [key]: true }));
    };
  }, []);

  const showAdSpace = useMemo(() => {
    if (isTestMode) return true;
    return slotKeys.some((key) => filledSlots[key] === true);
  }, [isTestMode, filledSlots, slotKeys]);

  return { showAdSpace, handleSlotFilled };
};
